var atomicsMapTransfer = {
    transfer: ['flex', 'box-border', 'relative', 'text-sm', 'text-gray-700'],
    list: [
        'flex',
        'flex-col',
        'border',
        'border-solid',
        'border-gray-200',
        'rounded-sm',
        'w-px-178',
        'h-px-230',
    ],
    header: [
        'flex',
        'items-center',
        'h-px-40',
        'border-b',
        'border-solid',
        'border-gray-200',
        'p-px-8',
    ],
    itemTotal: ['pl-px-10'],
    title: ['truncate', 'text-center', 'flex-auto', 'w-px-50'],
    body: ['flex', 'flex-auto', 'flex-col', 'overflow-hidden'],
    content: ['flex', 'overflow-auto', 'flex-col'],
    listItem: [
        'flex',
        'items-center',
        'overflow-hidden',
        'min-h-px-32',
        'p-px-8',
        'cursor-pointer',
        'hover:bg-gray-100',
    ],
    listItemDisable: [
        'flex',
        'items-center',
        'overflow-hidden',
        'min-h-px-32',
        'px-px-8',
        'cursor-pointer',
        'bg-gray-200',
    ],
    listItemCheck: [
        'flex',
        'items-center',
        'overflow-hidden',
        'min-h-px-32',
        'p-px-8',
        'cursor-pointer',
        'bg-brand-50',
    ],
    listItemTitle: [
        'flex',
        'items-center',
        'overflow-hidden',
        'min-h-px-32',
        'p-px-8',
        'truncate',
        'flex-auto',
    ],
    listItemTitleDisabled: ['text-gray-400', 'cursor-not-allowed'],
    operation: ['flex', 'flex-col', 'items-center', 'mx-px-8', 'justify-center', 'w-px-50'],
    btnLeft: ['flex', 'w-px-24', 'h-px-24', 'justify-center', 'bg-brand-600', 'border-brand-600'],
    btnRight: [
        'flex',
        'w-px-24',
        'h-px-24',
        'mb-px-16',
        'justify-center',
        'bg-brand-600',
        'border-brand-600',
    ],
};
export default atomicsMapTransfer;
